import React from 'react';
import CloseIcon from '@material-ui/icons/Close';
import DoneIcon from '@material-ui//icons/Done';
import { Button } from '@material-ui/core';
import { useDispatch } from 'dva';
import { history, useLocation } from 'umi';
import ButtonGroupStyled from './ButtonGroupStyled';
import { createOid } from '@/utils/eventtracing';

const ButtonGroup = ({ saveRef }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { query } = location;
  const { opt } = query;
  const handleClickExit = () => {
    dispatch({
      type: 'adjustDetail/save',
      payload: {
        values: {
          memberDetail: {},
        },
      },
    });
    history.goBack();
  };
  //更新会员详情

  return (
    <ButtonGroupStyled>
      <Button
        variant="contained"
        color="secondary"
        className="exit"
        onClick={handleClickExit}
        startIcon={<CloseIcon sx={{ width: '16px', height: '16px' }} />}
      >
        退出
      </Button>
      {!opt && (
        <Button
          data-log={JSON.stringify({
            oid: createOid('ev'),
            events: ['_ev'],
            params: {
              initUrl: window.location.origin + window.location.pathname,
            },
          })}
          ref={saveRef}
          variant="contained"
          type="submit"
          className="search"
          startIcon={<DoneIcon sx={{ width: '16px', height: '16px' }} />}
        >
          确认
        </Button>
      )}
    </ButtonGroupStyled>
  );
};
export default ButtonGroup;
